import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-toggle',
  imports: [
    NgClass
  ],
  templateUrl: './toggle.component.html',
  standalone: true,
  styleUrl: './toggle.component.scss'
})
export class ToggleComponent {
  @Input() toggled = false;
  @Output() onChange = new EventEmitter<boolean>();

  public toggle() {
    this.onChange.emit(!this.toggled);
  }
}
